export const Questions = [
  {
    question:
      'I want to receive emails about new products and exciting Cannon Safe news!',
    options: [
      {
        label: 'Yes, give me the details',
      },
      {
        label: 'No, I’ll be the last to know',
      },
    ],
    answer: 'Yes, give me the details',
  },
  {
    question:
      'I want to be among the first to try new products and become part of the Cannon Safe brand panel.',
    options: [
      {
        label:
          'Yes, I want to receive insider exclusives and provide product feedback',
      },
      {
        label: 'No, I don’t like exclusive news',
      },
    ],
    answer:
      'Yes, I want to receive insider exclusives and provide product feedback',
  },
];
